import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { VideoSeasonInput } from "../store/actionType";
import { createVideoSeason } from "../store/action";
import {
  CreateSeasonForm,
} from "modules/video/components/CreateFolderForm";
import { VideoSeriesProps } from "modules/video/series/store/actionType";
import { ApiError } from "components";

interface CreateSeasonProps {
  seriesFolderData: VideoSeriesProps;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CreateSeasonProps;

const CreateSeason: React.FC<Props> = ({
  closeModal,
  seriesFolderData,
  onCreateVideoSeason,
}) => {
  const [loading, setLoading] = useState(false);
  const [title, settitle] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);
   const [apiError, setApiError] = useState(null);
   const videoSeasonsState = useSelector(
    (state: any) => state.videoSeasons.videoSeasonsState
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    settitle(e.target.value);
    setError(null);
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    var input: VideoSeasonInput = {
      title: title,
      series_id: seriesFolderData.id.toString(),
      series_folder_id: seriesFolderData.folder_id.toString(),
    };
    if (title.trim() === "") {
      setError("Season name is required");
      return;
    } else {
      setLoading(true);
      onCreateVideoSeason(input);
      setSubmitted(true)
      setLoading(false);
    }
  };
    useEffect(() => {
        if (!videoSeasonsState.isLoading && submitted) {
          if (videoSeasonsState.error) {
            setApiError(videoSeasonsState.error); // show error
          } else {
            setApiError(null);
            closeModal(false);
          }
        }
      }, [videoSeasonsState.isLoading, videoSeasonsState.error, submitted, closeModal]);
  return (
    <>
      <CreateSeasonForm
        handleChange={handleChange}
        handleSubmit={handleSave}
        title={title}
        titleError={error}
        loading={loading}
        header={"Create Season"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onCreateVideoSeason: (input: VideoSeasonInput) =>
    dispatch(createVideoSeason(input)),
});

export default connect(null, mapDispatchToProps)(CreateSeason);
